export default __webpack_public_path__ + "static/media/AllProductItems1.609bc3f7.png";